import React, { useState, useEffect } from 'react';
import Swiper from 'swiper';

import mediaIcon from './icons/media.png';
import serviceIcon from './icons/service.png';
import faIcon from './icons/fa.png';
import zhikuIcon from './icons/zhiku.png';
import Dialog from '../../components/Dialog/Dialog';
import './About.scss';
import './MediaQuery.scss';
import { timeline } from './timeline';
import {
  lanxiongDesc,
  mediaDesc,
  zhikuDesc,
  FADesc,
  serviceDesc,
  reportList,
} from './doc';

import { setWechatShare } from '../../utils';
interface Props {
  getPath: (path: string) => void;
}

const About: React.FC<Props> = props => {
  useEffect(() => {
    props.getPath('/');
    const title = '关于懒熊-懒熊体育-让体育产业高效连接';

    document.title = title;

    new Swiper('#reports-swiper', {
      slidesPerView: 4,
      spaceBetween: 20,
      slidesPerGroup: 4,
      speed: 500,
      navigation: {
        nextEl: '#swiper-button-next3',
        prevEl: '#swiper-button-prev3',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        // type: 'custom'
      },
    });

    new Swiper('#m-swiper', {
      slidesPerView: 1.4285,
      spaceBetween: 15,
      speed: 500,
    });

    setWechatShare({
      title,
    });
  }, [props]);

  const [visible, setVisible] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  const showDialog = (title: string, content: string) => {
    setVisible(true);
    setTitle(title);
    setContent(content);
    document.body.classList.add('fix');
  };

  return (
    <div className="About">
      <section className="banner">让体育产业高效连接</section>
      <article className="article">
        <pre>{lanxiongDesc}</pre>
      </article>
      <section className="businesses-wrapper">
        <h2 className="section-title">主要业务</h2>
        <ul className="businesses">
          <li
            className="item"
            onClick={() => {
              showDialog('内容创作', mediaDesc);
            }}
          >
            <div className="icon-wrapper">
              <img src={mediaIcon} alt="" />
            </div>
            <p>内容创作</p>
          </li>
          <li
            className="item"
            onClick={() => {
              showDialog('智库培训', zhikuDesc);
            }}
          >
            <div className="icon-wrapper">
              <img src={zhikuIcon} alt="" />
            </div>
            <p>智库培训</p>
          </li>
          <li
            className="item"
            onClick={() => {
              showDialog('金融咨询', FADesc);
            }}
          >
            <div className="icon-wrapper">
              <img src={faIcon} alt="" />
            </div>
            <p>金融咨询</p>
          </li>
          <li
            className="item"
            onClick={() => {
              showDialog('企业服务', serviceDesc);
            }}
          >
            <div className="icon-wrapper">
              <img src={serviceIcon} alt="" />
            </div>
            <p>企业服务</p>
          </li>
        </ul>
      </section>
      <section className="founding-team">
        <h2 className="founding-team-title section-title">创始团队</h2>
        <ul className="content">
          <li>
            <img
              src="https://imgcdn.lanxiongsports.com/lx-aboutHan_Mu.png"
              alt="韩牧"
            />
            <div className="info">
              <h4>韩牧</h4>
              <p className="title">懒熊体育创始人&CEO</p>
              <p className="desc">
                曾出版小说集多部，创业之前为商业记者，采访包含姚明等在内的百余位商业和体育大佬。
              </p>
            </div>
          </li>
          <li>
            <img
              src="https://imgcdn.lanxiongsports.com/lx-about/lishuangfu.png"
              alt="黎双富"
            />
            <div className="info">
              <h4>黎双富</h4>
              <p className="title">懒熊体育总裁</p>
              <p className="desc">
                前知名NBA驻美记者，现懒熊体育联合创始人，是首个跟队进白宫采访的中国NBA记者，著有《斯特恩传》、《NBA与商业》等。
              </p>
            </div>
          </li>
        </ul>
      </section>
      <section className="timeline">
        <h2 className="section-title timeline-title">发展历程</h2>
        <ul className="timeline-list">
          {timeline.map(timelineItem => (
            <li className="timeline-item" key={timelineItem.year}>
              <div className="timeline-left">
                <span className="year">
                  {timelineItem.year}年{timelineItem.year === 2014 ? '初' : ''}
                </span>
              </div>
              <div className="timeline-tail"></div>
              <ul className="timeline-content">
                {timelineItem.items.map(monthItem => (
                  <li key={monthItem.text}>
                    {monthItem.month !== null && <h4>{monthItem.month}月</h4>}
                    <pre>{monthItem.text}</pre>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </section>
      <section className="media-reports-wrapper">
        <h2 className="section-title media-reports-wrapper-title">媒体报道</h2>
        <div className="content">
          <div className="btn-wrapper">
            <div className="swiper-button-prev" id="swiper-button-prev3"></div>
          </div>
          <div className="swiper-container" id="reports-swiper">
            <div className="swiper-wrapper">
              {reportList.map(item => (
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="swiper-slide"
                  key={item.link}
                >
                  <div className="logo">
                    <img src={item.logo} alt={item.name} />
                  </div>
                  <p className="title">{item.title}</p>
                </a>
              ))}
            </div>
          </div>
          <div className="btn-wrapper right-btn">
            <div className="swiper-button-next" id="swiper-button-next3"></div>
          </div>
          <div className="swiper-container" id="m-swiper">
            <div className="swiper-wrapper">
              {reportList.map(item => (
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="swiper-slide"
                  key={item.link}
                >
                  <div className="logo">
                    <img src={item.logo} alt={item.name} />
                  </div>
                  <p className="title">{item.title}</p>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Dialog
        title={title}
        Content={content}
        visible={visible}
        onCancel={() => {
          document.body.classList.remove('fix');
          setVisible(false);
        }}
      ></Dialog>
    </div>
  );
};

export default About;
